import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isDarkMode } from '../../../store/selectors/settingSelectors';
import ResultsHeader from './ResultsHeader/ResultsHeader';
import ResultRow from './ResultRow/ResultRow';
const ResultsCard = ({ result, filters, onResultClick }) => {
    const darkMode = useSelector(isDarkMode);
    const handleClick = (raceDetails) => {
        onResultClick(raceDetails);
    };
    const allResults = useMemo(() => result.map((race) => (_jsx(ResultRow, { onClick: handleClick, raceDetails: race, darkMode: darkMode, collapsed: filters }, race.id))), [result, filters]);
    return (_jsxs(_Fragment, { children: [_jsx(ResultsHeader, { collapsed: filters }), allResults] }));
};
export default ResultsCard;
